import React, { useState, useEffect } from 'react';

const ExpandableText = ({ title, text, id, historicalRefSelected, startExpanded = false, length = 159, callback }) => {
  const [expanded, setExpanded] = useState(startExpanded);
  const [isSelected, setIsSelected] = useState(startExpanded)

  useEffect(() => {
    if (historicalRefSelected === id) {
      setExpanded(true);
      setIsSelected(true)
    } else {
      setExpanded(false);
      setIsSelected(false)
    }
  }, [historicalRefSelected, id]);

  const handleClick = () => {
    setExpanded(!expanded);
    if (!expanded) {
      callback();
    }
  };

  return (
    <div className={`expandable-container ${isSelected ? "expanded" : ""}`}>
      <p className="primaryFont title">{title}</p>
      <p>
        {expanded ? text : (text.length > length ? text.slice(0, length) + '...' : text)}
      </p>
      <div className="d-flex justify-content-end">
        <button
          id={`expandable-${id}`}
          onClick={handleClick}
          className={expanded ? "expanded" : ""}
        >
          {expanded ? "Menos info +" : "Más info +"}
        </button>
      </div>
    </div>
  );
};

export default ExpandableText;
